/* Collection and search filters: submits the form with fetch and swaps the grid and the filter panel. */
(function () {
  var form = document.getElementById('FiltersForm');
  if (!form) return;
  var timer = null;

  function params() {
    var fd = new FormData(form);
    var p = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
    var sort = document.getElementById('SortBy');
    if (sort && sort.value && !p.has('sort_by')) p.set('sort_by', sort.value);
    return p;
  }

  function load(url, push) {
    document.documentElement.classList.add('ajax-loading');
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['grid', 'filters'].forEach(function (name) {
          var cur = document.querySelector('[data-filter-region="' + name + '"]');
          var next = doc.querySelector('[data-filter-region="' + name + '"]');
          if (cur && next) cur.replaceWith(next);
        });
        if (push) history.pushState(null, '', url);
        form = document.getElementById('FiltersForm');
        bind();
        document.dispatchEvent(new CustomEvent('grid:updated'));
      })
      .catch(function () { window.location.href = url; })
      .then(function () { document.documentElement.classList.remove('ajax-loading'); });
  }

  function submit() {
    var p = params();
    var base = form.getAttribute('action') || window.location.pathname;
    var qs = p.toString();
    load(base + (qs ? '?' + qs : ''), true);
  }

  function bind() {
    form = document.getElementById('FiltersForm');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      submit();
    });
    form.addEventListener('input', function (e) {
      if (e.target.type !== 'number') return;
      clearTimeout(timer);
      timer = setTimeout(submit, 600);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    var sort = document.getElementById('SortBy');
    if (sort) sort.addEventListener('change', submit);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.active-f a, .pagination a');
    if (!a) return;
    e.preventDefault();
    load(a.href, true);
    if (a.closest('.pagination')) {
      var g = document.getElementById('ProductGridContainer');
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  window.addEventListener('popstate', function () { load(window.location.href, false); });
  bind();
})();
